export default __webpack_public_path__ + "static/emoji-2e8e22105a235f47cc00c74df81fe988.svg";